import { render, staticRenderFns } from "./DetalheCobranca.vue?vue&type=template&id=45740113"
import script from "./DetalheCobranca.vue?vue&type=script&lang=ts"
export * from "./DetalheCobranca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports